import { Box, Typography } from "@mui/material"
import { theme } from "../util/theme"

export const DayCell = ({
  text,
  active,
}: {
  text: string | number
  active: boolean
}) => {
  return (
    <Box
      minWidth={60}
      minHeight={30}
      border={"1px solid lightgray"}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      bgcolor={active ? theme.mainIndicationColor : "white"}
      sx={{ cursor: "pointer" }}
    >
      <Typography
        variant="label"
        sx={{ color: active ? "white" : theme.blackColorLabel }}
      >
        {text}
      </Typography>
    </Box>
  )
}
